exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".issuu-embed-container[data-v-7f755c68] {\n  position: relative;\n  padding-bottom: 56.25%;\n  /* set the aspect ratio here as (height / width) * 100% */\n  height: 0;\n  overflow: hidden;\n  max-width: 100%;\n}\n.issuu-embed-container iframe[data-v-7f755c68] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports
